// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  text-align: left;
}

.form-group label {
  margin-left: 0.75em;
}

/* Style the select box */
select {
  width: 100%; /* Make the select box full-width */
  padding: 10px; /* Add padding for better touch interaction */
  font-size: 16px; /* Adjust font size as needed */
}

/* Style the dropdown arrow icon (optional) */
select::-ms-expand {
  display: none; /* Remove the default arrow icon in IE */
}
select::-webkit-select-arrow {
  display: none; /* Remove the default arrow icon in Chrome and Safari */
}

/* Style the options */
select option {
  font-size: 14px; /* Adjust font size as needed */
}

.mt-3 {
  margin-left: 11em !important;
}

.btn-cons, .btnAdminManage {
  background-color: #0077B5;
  color: #ffffff;
}

.btn.btn-cons:hover, .btn.btn-cons:focus, .btn.btnAdminManage:hover, .btn.btnAdminManage:focus {
	background-color: #3788d8 !important;
  color: #FFFFFF;
}

/* SWITCH 4 */

.onoffswitch4
{
    position: relative;
    width: 110px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select: none;
}

.onoffswitch4-checkbox {
    display: none;
}

.onoffswitch4-label {
    display: block; overflow: hidden; cursor: pointer;
    border: 0px solid #999999; border-radius: 0px;
}

.onoffswitch4-inner {
    display: block; width: 200%; margin-left: -100%; transition: margin 0.3s ease-in 0s;
}

.onoffswitch4-inner > span {
    display: block; float: left; position: relative; width: 50%; height: 30px; padding: 0; line-height: 30px;
    font-size: 14px; color: white; font-family: Trebuchet, Arial, sans-serif; font-weight: bold; box-sizing: border-box;
}

.onoffswitch4-inner .onoffswitch4-active {
    padding-left: 10px;
    margin-top: 10px;
    background-color: #EEEEEE; color: #FFFFFF;
}

.onoffswitch4-inner .onoffswitch4-inactive {
    padding-right: 10px;
    margin-top: 10px;
    background-color: #EEEEEE; color: #FFFFFF;
    text-align: right;
}

.onoffswitch4-switch {
    display: block; width: 18px; margin: 0px; text-align: center;
    border: 0px solid #999999;border-radius: 0px;
    position: absolute; top: 0; bottom: 0;
}
.onoffswitch4-active .onoffswitch4-switch {
    background: red; left: 0;
}
.onoffswitch4-inactive .onoffswitch4-switch {
    background: #27A1CA; right: 0;
}

.onoffswitch4-active .onoffswitch4-switch:before {
    content: " "; position: absolute; top: 0; left: 18px;
    border-style: solid; border-color: red transparent transparent red; border-width: 15px 37px;
}

.onoffswitch4-inactive .onoffswitch4-switch:before {
    content: " "; position: absolute; top: 0; right: 18px;
    border-style: solid; border-color: transparent #27A1CA #27A1CA transparent; border-width: 17px 40px;
}

.onoffswitch4-checkbox:checked + .onoffswitch4-label .onoffswitch4-inner {
    margin-left: 0;
}

.error {
  margin-left: 5px;
  color: red;
  font-size: 12px;
}

.height-90 {
  margin-left: -5px;
  height: 110px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

@media (max-width: 992px) {
  .height-90 {
    height: auto;
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/Components/UsersAdministration/tabs/user-information-tab/user-information-tab.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW,EAAE,mCAAmC;EAChD,aAAa,EAAE,6CAA6C;EAC5D,eAAe,EAAE,+BAA+B;AAClD;;AAEA,6CAA6C;AAC7C;EACE,aAAa,EAAE,wCAAwC;AACzD;AACA;EACE,aAAa,EAAE,uDAAuD;AACxE;;AAEA,sBAAsB;AACtB;EACE,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;CACC,oCAAoC;EACnC,cAAc;AAChB;;AAEA,aAAa;;AAEb;;IAEI,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc,EAAE,gBAAgB,EAAE,eAAe;IACjD,yBAAyB,EAAE,kBAAkB;AACjD;;AAEA;IACI,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAER,kCAAkC;AAC7E;;AAEA;IACI,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE,UAAU,EAAE,YAAY,EAAE,UAAU,EAAE,iBAAiB;IACxG,eAAe,EAAE,YAAY,EAAE,yCAAyC,EAAE,iBAAiB,EAC9B,sBAAsB;AACvF;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAE,cAAc;AAC7C;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB,EAAE,cAAc;IACzC,iBAAiB;AACrB;;AAEA;IACI,cAAc,EAAE,WAAW,EAAE,WAAW,EAAE,kBAAkB;IAC5D,yBAAyB,CAAC,kBAAkB;IAC5C,kBAAkB,EAAE,MAAM,EAAE,SAAS;AACzC;AACA;IACI,eAAe,EAAE,OAAO;AAC5B;AACA;IACI,mBAAmB,EAAE,QAAQ;AACjC;;AAEA;IACI,YAAY,EAAE,kBAAkB,EAAE,MAAM,EAAE,UAAU;IACpD,mBAAmB,EAAE,6CAA6C,EAAE,uBAAuB;AAC/F;;AAEA;IACI,YAAY,EAAE,kBAAkB,EAAE,MAAM,EAAE,WAAW;IACrD,mBAAmB,EAAE,qDAAqD,EAAE,uBAAuB;AACvG;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":[".form {\n  text-align: left;\n}\n\n.form-group label {\n  margin-left: 0.75em;\n}\n\n/* Style the select box */\nselect {\n  width: 100%; /* Make the select box full-width */\n  padding: 10px; /* Add padding for better touch interaction */\n  font-size: 16px; /* Adjust font size as needed */\n}\n\n/* Style the dropdown arrow icon (optional) */\nselect::-ms-expand {\n  display: none; /* Remove the default arrow icon in IE */\n}\nselect::-webkit-select-arrow {\n  display: none; /* Remove the default arrow icon in Chrome and Safari */\n}\n\n/* Style the options */\nselect option {\n  font-size: 14px; /* Adjust font size as needed */\n}\n\n.mt-3 {\n  margin-left: 11em !important;\n}\n\n.btn-cons, .btnAdminManage {\n  background-color: #0077B5;\n  color: #ffffff;\n}\n\n.btn.btn-cons:hover, .btn.btn-cons:focus, .btn.btnAdminManage:hover, .btn.btnAdminManage:focus {\n\tbackground-color: #3788d8 !important;\n  color: #FFFFFF;\n}\n\n/* SWITCH 4 */\n\n.onoffswitch4\n{\n    position: relative;\n    width: 110px;\n    -webkit-user-select:none;\n    -moz-user-select:none;\n    -ms-user-select: none;\n}\n\n.onoffswitch4-checkbox {\n    display: none;\n}\n\n.onoffswitch4-label {\n    display: block; overflow: hidden; cursor: pointer;\n    border: 0px solid #999999; border-radius: 0px;\n}\n\n.onoffswitch4-inner {\n    display: block; width: 200%; margin-left: -100%;\n    -moz-transition: margin 0.3s ease-in 0s; -webkit-transition: margin 0.3s ease-in 0s;\n    -o-transition: margin 0.3s ease-in 0s; transition: margin 0.3s ease-in 0s;\n}\n\n.onoffswitch4-inner > span {\n    display: block; float: left; position: relative; width: 50%; height: 30px; padding: 0; line-height: 30px;\n    font-size: 14px; color: white; font-family: Trebuchet, Arial, sans-serif; font-weight: bold;\n    -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box;\n}\n\n.onoffswitch4-inner .onoffswitch4-active {\n    padding-left: 10px;\n    margin-top: 10px;\n    background-color: #EEEEEE; color: #FFFFFF;\n}\n\n.onoffswitch4-inner .onoffswitch4-inactive {\n    padding-right: 10px;\n    margin-top: 10px;\n    background-color: #EEEEEE; color: #FFFFFF;\n    text-align: right;\n}\n\n.onoffswitch4-switch {\n    display: block; width: 18px; margin: 0px; text-align: center;\n    border: 0px solid #999999;border-radius: 0px;\n    position: absolute; top: 0; bottom: 0;\n}\n.onoffswitch4-active .onoffswitch4-switch {\n    background: red; left: 0;\n}\n.onoffswitch4-inactive .onoffswitch4-switch {\n    background: #27A1CA; right: 0;\n}\n\n.onoffswitch4-active .onoffswitch4-switch:before {\n    content: \" \"; position: absolute; top: 0; left: 18px;\n    border-style: solid; border-color: red transparent transparent red; border-width: 15px 37px;\n}\n\n.onoffswitch4-inactive .onoffswitch4-switch:before {\n    content: \" \"; position: absolute; top: 0; right: 18px;\n    border-style: solid; border-color: transparent #27A1CA #27A1CA transparent; border-width: 17px 40px;\n}\n\n.onoffswitch4-checkbox:checked + .onoffswitch4-label .onoffswitch4-inner {\n    margin-left: 0;\n}\n\n.error {\n  margin-left: 5px;\n  color: red;\n  font-size: 12px;\n}\n\n.height-90 {\n  margin-left: -5px;\n  height: 110px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n}\n\n@media (max-width: 992px) {\n  .height-90 {\n    height: auto;\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
